module.exports = __webpack_public_path__ + "img/back.67fbdf6b.png";